import { init as initApm } from '@elastic/apm-rum'

var apm = initApm({
 serviceName: 'CollectionUI',
 serviceVersion: '1',
 serverUrl: process.env.ELK_URL,
})
export default apm;